<template>
  <div v-if="geoContent">
    <add-user-license :gcid="geoContent.id" class="my-3"></add-user-license>
    <p v-if="licenses && licenses.length == 0">{{ $t('publisher.gc.lics.nolics') }}</p>
    <table class="table table-sm mt-3" v-else-if="licenses && licenses.length">
      <thead>
        <tr>
          <th>{{ $t('publisher.gc.lics.issued') }}</th>
          <th>{{ $t('publisher.gc.lics.expired') }}</th>
          <th>{{ $t('publisher.gc.lics.lictype') }}</th>
          <th>{{ $t('publisher.gc.lics.devnum') }}</th>
          <th>{{ $t('publisher.gc.lics.consumed') }}</th>
          <th>{{ $t('publisher.gc.lics.userid') }}</th>
          <th>{{ $t('publisher.gc.lics.issuer') }}</th>
          <th></th>
        </tr>
      </thead>
      <tr v-for="lic in licenses" :key="lic.license.id">
        <td><my-date :date="lic.license.issued"></my-date></td>
        <td><my-date :date="lic.license.expirationDate"></my-date></td>
        <td>{{lic.license.product.licType}} <span v-if="lic.license.product.licType === 'com'">({{ $t('publisher.gc.lics.price') }}: {{lic.license.price}})</span></td>
        <td>{{lic.license.deviceCount}}</td>
        <td>
          <span
            v-if="consumptionLoading"
            class="spinner-border spinner-border-sm text-secondary"
            role="status"
            aria-hidden="true"
          ></span>
          <template v-else>{{ consumedFor(lic.license.id) }}</template>
        </td>
        <td>{{lic.license.user.email}}</td>
        <td>
          <span v-if="lic.issuer">{{lic.issuer.title}} ({{lic.license.issuerType}})</span>
          <i v-else-if="lic.license.issuerType === 'iOS'" class="fab fa-apple"></i>
          <i v-else-if="lic.license.issuerType === 'Android'" class="fab fa-android"></i>
          <span v-else-if="lic.license.issuerType === 'publisher'"> - </span>
        </td>
        <td>
          <button
            v-if="canRemove(lic)"
            type="button"
            class="btn btn-sm btn-link text-danger text-decoration-none px-0"
            :disabled="removingId === lic.license.id"
            @click="removePermit(lic)"
          >
            <span
              v-if="removingId === lic.license.id"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <template v-else>{{ $t('publisher.gc.lics.remove') }}</template>
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import AddUserLicense from "@/components/AddUserLicense";

export default {
  components: {
    AddUserLicense
  },
  data() {
    return {
      removingId: null
    };
  },
  computed: {
    licenses() {
      return this.$store.state.geoContent.licenses;
    },
    geoContent() {
      return this.$store.state.geoContent.geoContent;
    },
    consumptionLoading() {
      return this.$store.state.geoContent.licenseConsumptionLoading;
    },
    licenseConsumption() {
      return this.$store.state.geoContent.licenseConsumption;
    }
  },
  watch: {
    "geoContent.id": {
      immediate: true,
      handler(gcid) {
        if (gcid) {
          this.$store.dispatch("geoContent/getLicenses", gcid);
        }
      }
    }
  },
  methods: {
    consumedFor(licenseId) {
      if (!this.licenseConsumption) {
        return "—";
      }
      var value = this.licenseConsumption[licenseId];
      return value == null ? 0 : value;
    },
    canRemove(lic) {
      return lic.license && lic.license.issuerType === "publisher";
    },
    removePermit(lic) {
      if (this.removingId || !lic.license || !lic.license.user) {
        return;
      }
      var email = lic.license.user.email;
      if (!window.confirm(this.$t("publisher.gc.lics.remove_confirm", { email }))) {
        return;
      }
      this.removingId = lic.license.id;
      this.$store
        .dispatch("geoContent/removePermit", {
          gcid: this.geoContent.id,
          userid: lic.license.user.id,
          prodid: lic.license.productId
        })
        .finally(() => {
          this.removingId = null;
        });
    },
    prodShort(license) {
      var prod = license.product
      var short = prod.licType.toUpperCase() + " [";
      if (prod.enc) short += "ENC, ";
      if (prod.ais) short += "AIS, ";
      if (prod.ntm) short += "NTM, ";
      if (prod.poi) short += "POI, ";
      if (prod.weather) short += "WTHR, ";
      if (prod.noaaWeather) short += "WTHR(NOAA), ";
      if (prod.navMsg) short += "NMSG, ";
      short = short.slice(0, -2);
      short += "]";
      if (prod.licType === "com") {
        short += " - Price: " + license.price;
      }
      return short;
    }
  }
};
</script>

<style scoped>
th {
  color: grey;
}

i.fab {
  color: #0069D9;
}
</style>
